import { Modal, Input, Checkbox, Select } from "antd";
import { displayMessage } from "../../services/helper";
import api from "../../services/api";
import { useEffect, useState, useContext } from "react";
import SL_Button from "../buttons/Button";
import GeneralContext from "../../context/GeneralContext/GeneralContext";
import { MultiSelect } from "../selects/MultiSelect";
import {AxiosError} from "axios"
import EDaysOfTheWeek from "../../enums/EDaysOfTheWeek";
import ELanguages from "../../enums/ELanguages";

const { Option } = Select;
const ProtocolDetailsModal = ({
  isPatientProtocolModalOpen,
  setIsPatientProtocolModalOpen,
  selectedRow,
  setSelectedRow,
  patientId,
  refreshProtocolExercises
}) => {
  const { setShowLoading } = useContext(GeneralContext);
  const [protocol, setProtocol] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editedData, setEditedData] = useState({
    name: "",
    description: "",
    scheduledDays: [],
  });
  const [scheduledDays, setScheduledDays] = useState([]);
  const [language, setLanguage] = useState([])


  const mountProtocolOptions = async (e) => {
    try {

      const { data } = await api.protocols.listProtocolsByTarget({ value: e, language: language.code });

      return data.map((protocol) => ({
        label: protocol?.name,
        value: protocol?.id,
      }));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      if (selectedRow) {
        const lang = Object.values(ELanguages).find(
          (l) => l.code === +selectedRow?.protocol.language 
        );
        setLanguage(lang)
        setEditedData({
          name: selectedRow?.name,
          description: selectedRow?.description,
          scheduledDays: selectedRow.scheduledDays,
          language: selectedRow?.protocol.language
        });

       
        if (selectedRow?.protocolId && selectedRow?.name) {
          setProtocol([{
            label: selectedRow.name,
            value: selectedRow.protocolId
          }]);
        }
      }
    };

    loadData();
  }, [selectedRow]);

  const getDayName = (dayNumber) => {
    const day = Object.values(EDaysOfTheWeek).find(d => d.code === dayNumber);
    return day.label;
  };

  const weekDays = Object.values(EDaysOfTheWeek).map(day => ({
    value: day.code,
    label: day.label,
  }));
  
  const handleEdit = () => {
    setIsEditing(true);
    
    if (selectedRow?.protocolId && selectedRow?.name && protocol.length === 0) {
      setProtocol([{
        label: selectedRow.name,
        value: selectedRow.protocolId
      }]);
    }
  };

  const handleCancel = () => {
    if (isEditing) {
      setEditedData({
        name: selectedRow?.name,
        description: selectedRow?.description,
        scheduledDays: scheduledDays,
      });
      
      if (selectedRow?.protocolId && selectedRow?.name) {
        setProtocol([{
          label: selectedRow.name,
          value: selectedRow.protocolId
        }]);
      }
      
      setIsPatientProtocolModalOpen(false);
    } else {
      setIsPatientProtocolModalOpen(false);
    }
  };

  const handleEditProtocol = async () => {
    setShowLoading(true);
    try {
      await api.patient_protocol.updatePatientProtocol(patientId.id, {
        ...editedData,
        selectedRow,
        protocol: protocol[0]
      });

      setScheduledDays(editedData.scheduledDays);
      setIsEditing(false);
      setIsPatientProtocolModalOpen(false)
      refreshProtocolExercises()
      setSelectedRow(null)
      alert(displayMessage("UPDATE_PROTOCOL_SUCCESS"), "success");
    } catch (error) {
      if (error?.response?.data?.error && error instanceof AxiosError){
        alert(error?.response?.data?.error, "error")
        return
      }
      alert(displayMessage("UPDATE_PROTOCOL_ERROR"), "error");
    } finally {
      setShowLoading(false);
    }
  };

  const handleDayChange = (dayValue, checked) => {
    setEditedData((prev) => ({
      ...prev,
      scheduledDays: checked
        ? [...prev.scheduledDays, dayValue].sort((a, b) => a - b)
        : prev.scheduledDays.filter((day) => day !== dayValue),
    }));
  };

  return (
    <Modal
      visible={isPatientProtocolModalOpen}
      onCancel={handleCancel}
      title={
        <div className="text-xl font-bold">
          {isEditing
            ? displayMessage("EDIT_PROTOCOL")
            : displayMessage("PROTOCOL_DETAILS")}
        </div>
      }
      footer={null}
      width={600}
    >
      <div className="p-5">
      <div className="mb-4">
          <label className="block text-sm font-medium mb-2">
            {displayMessage("LANGUAGE")}:
          </label>
          {isEditing ? (
            <Select
            onChange={(value)=>{
              setLanguage(Object.values(ELanguages).find(l=>l.code===value))
              setProtocol([])
              setScheduledDays([])
              handleDayChange([], false)
              
            }}
              placeholder={displayMessage("LANGUAGE")}
              value={language.code}
            >
  {Object.values(ELanguages).map((type) => (
    <Option key={type.code} value={type.code}>
        {type.description}
    </Option>
))}
            </Select>
          ) : (
            <p className="text-lg font-semibold">{language.description}</p>
          )}
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">
            {displayMessage("NAME")}:
          </label>
          {isEditing ? (
            <MultiSelect
              allowClear
              fetchOptions={mountProtocolOptions}
              placeholder={displayMessage("ADD_PROTOCOL")}
              value={protocol}
              onChange={(value) => setProtocol(value?.slice(-1))}
            />
          ) : (
            <p className="text-lg font-semibold">{selectedRow?.name}</p>
          )}
        </div>
        <div className="mb-4">
          {!isEditing && (
            <>
              {" "}
              <label className="block text-sm font-medium mb-2">
                {displayMessage("DESCRIPTION")}:
              </label>
              <p className="text-gray-600">{selectedRow?.description}</p>
            </>
          )}
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium mb-3">
            {displayMessage("SCHEDULE_DAYS")}:
          </label>

          {isEditing ? (
            <div className="grid grid-cols-2 gap-2">
              {weekDays.map((day) => (
                <Checkbox
                  key={day.value}
                  checked={editedData.scheduledDays.includes(day.value)}
                  onChange={(e) => handleDayChange(day.value, e.target.checked)}
                >
                  {day.label}
                </Checkbox>
              ))}
            </div>
          ) : (
            <div className="flex flex-wrap gap-2">
              {selectedRow?.scheduledDays?.map((day) => (
                <span
                  key={day}
                  className="px-3 py-1 bg-gray-100 rounded-md text-sm"
                >
                  {getDayName(day)}
                </span>
              ))}
            </div>
          )}
        </div>

        <div className="flex gap-2 justify-end">
          <SL_Button onClick={handleCancel}>
            {displayMessage("CANCEL")}
          </SL_Button>

          {isEditing ? (
            <SL_Button onClick={handleEditProtocol} type="primary">
              {displayMessage("SAVE")}
            </SL_Button>
          ) : (
            <SL_Button onClick={handleEdit} type="primary">
              {displayMessage("EDIT")}
            </SL_Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ProtocolDetailsModal;